// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Semver = require("semver");
var TypeUtils = require("./TypeUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Map = require("relude/src/Relude_Map.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var StringUtils = require("../StringUtils.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");
var Relude_Ordering = require("relude/src/Relude_Ordering.bs.js");
var CommonTypes_User_Id = require("./CommonTypes_User_Id.bs.js");
var CommonTypes_PhoneNumber = require("./CommonTypes_PhoneNumber.bs.js");

function toggle(param) {
  if (param) {
    return /* Ascending */0;
  } else {
    return /* Descending */1;
  }
}

var SortOrder = {
  toggle: toggle
};

var Url = TypeUtils.MakeOpaqueStringType({});

function make(input) {
  return Relude_Array.mapOption((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_String.splitArray("=", param);
                            }), (function (param) {
                              if (param.length !== 2) {
                                return ;
                              }
                              var name = param[0];
                              var value = param[1];
                              return {
                                      name: name,
                                      value: decodeURIComponent(value)
                                    };
                            }), param);
              }), input.split("&"));
}

var QueryStringParameters = {
  make: make
};

function toEnum(param) {
  switch (param) {
    case 0 :
        return /* Local */0;
    case 1 :
        return /* Dev */1;
    case 2 :
        return /* Staging */2;
    case 3 :
        return /* Prod */3;
    case 4 :
        return /* SevenShift */4;
    case 5 :
        return /* Mate */6;
    case 6 :
        return /* Kuba */5;
    default:
      return ;
  }
}

function fromEnum(param) {
  return param;
}

var include = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum,
      toEnum: toEnum
    });

function fromString(param) {
  return Relude_Globals.$great$great(Relude_String.toLowerCase, (function (param) {
                switch (param) {
                  case "7shift" :
                      return /* SevenShift */4;
                  case "dev" :
                  case "development" :
                      return /* Dev */1;
                  case "kuba" :
                      return /* Kuba */5;
                  case "local" :
                      return /* Local */0;
                  case "mate" :
                      return /* Mate */6;
                  case "prod" :
                  case "production" :
                      return /* Prod */3;
                  case "staging" :
                      return /* Staging */2;
                  default:
                    return ;
                }
              }), param);
}

function toString(param) {
  switch (param) {
    case /* Local */0 :
        return "local";
    case /* Dev */1 :
        return "dev";
    case /* Staging */2 :
        return "staging";
    case /* Prod */3 :
        return "prod";
    case /* SevenShift */4 :
        return "7shift";
    case /* Kuba */5 :
        return "kuba";
    case /* Mate */6 :
        return "mate";
    
  }
}

var decode = Curry._1(Json.Decode.variantFromString, fromString);

function encode(param) {
  return Relude_Globals.$great$great(toString, (function (prim) {
                return prim;
              }), param);
}

var DeployEnv_fromEnum = include.fromEnum;

var DeployEnv_toEnum = include.toEnum;

var DeployEnv_eq = include.eq;

var DeployEnv_compare = include.compare;

var DeployEnv_Ord = include.Ord;

var DeployEnv_compareWithConversion = include.compareWithConversion;

var DeployEnv_compareReversed = include.compareReversed;

var DeployEnv_OrdReversed = include.OrdReversed;

var DeployEnv_compareAsInt = include.compareAsInt;

var DeployEnv_min = include.min;

var DeployEnv_max = include.max;

var DeployEnv_lessThan = include.lessThan;

var DeployEnv_lt = include.lt;

var DeployEnv_lessThanOrEq = include.lessThanOrEq;

var DeployEnv_lte = include.lte;

var DeployEnv_greaterThan = include.greaterThan;

var DeployEnv_gt = include.gt;

var DeployEnv_greaterThanOrEq = include.greaterThanOrEq;

var DeployEnv_gte = include.gte;

var DeployEnv_clamp = include.clamp;

var DeployEnv_between = include.between;

var DeployEnv_OrdRingExtensions = include.OrdRingExtensions;

var DeployEnv_OrdNamed = include.OrdNamed;

var DeployEnv_OrdBy = include.OrdBy;

var DeployEnv_Set = include.$$Set;

var DeployEnv_SetWithNone = include.SetWithNone;

var DeployEnv_Map = include.$$Map;

var DeployEnv_list = include.list;

var DeployEnv_array = include.array;

var DeployEnv_set = include.set;

var DeployEnv_setWithNone = include.setWithNone;

var DeployEnv_cardinality = include.cardinality;

var DeployEnv_top = include.top;

var DeployEnv_bottom = include.bottom;

var DeployEnv_succ = include.succ;

var DeployEnv_pred = include.pred;

var DeployEnv = {
  fromEnum: DeployEnv_fromEnum,
  toEnum: DeployEnv_toEnum,
  eq: DeployEnv_eq,
  compare: DeployEnv_compare,
  Ord: DeployEnv_Ord,
  compareWithConversion: DeployEnv_compareWithConversion,
  compareReversed: DeployEnv_compareReversed,
  OrdReversed: DeployEnv_OrdReversed,
  compareAsInt: DeployEnv_compareAsInt,
  min: DeployEnv_min,
  max: DeployEnv_max,
  lessThan: DeployEnv_lessThan,
  lt: DeployEnv_lt,
  lessThanOrEq: DeployEnv_lessThanOrEq,
  lte: DeployEnv_lte,
  greaterThan: DeployEnv_greaterThan,
  gt: DeployEnv_gt,
  greaterThanOrEq: DeployEnv_greaterThanOrEq,
  gte: DeployEnv_gte,
  clamp: DeployEnv_clamp,
  between: DeployEnv_between,
  OrdRingExtensions: DeployEnv_OrdRingExtensions,
  OrdNamed: DeployEnv_OrdNamed,
  OrdBy: DeployEnv_OrdBy,
  $$Set: DeployEnv_Set,
  SetWithNone: DeployEnv_SetWithNone,
  $$Map: DeployEnv_Map,
  list: DeployEnv_list,
  array: DeployEnv_array,
  set: DeployEnv_set,
  setWithNone: DeployEnv_setWithNone,
  cardinality: DeployEnv_cardinality,
  top: DeployEnv_top,
  bottom: DeployEnv_bottom,
  succ: DeployEnv_succ,
  pred: DeployEnv_pred,
  fromString: fromString,
  toString: toString,
  decode: decode,
  encode: encode
};

function toString$1(x) {
  if (typeof x !== "number") {
    return x._0;
  }
  switch (x) {
    case /* BusinessMobileAndroid */0 :
        return "business_mobile_android";
    case /* BusinessMobileIOS */1 :
        return "business_mobile_ios";
    case /* Legacy */2 :
        return "legacy";
    case /* ProfessionalMobileAndroid */3 :
        return "professional_mobile_android";
    case /* ProfessionalMobileIOS */4 :
        return "professional_mobile_ios";
    case /* Qwickio */5 :
        return "qwickio";
    case /* Server */6 :
        return "server";
    case /* Unspecified */7 :
        return "unspecified";
    case /* Web */8 :
        return "web";
    
  }
}

function fromString$1(x) {
  switch (x) {
    case "business_mobile_android" :
        return /* BusinessMobileAndroid */0;
    case "business_mobile_ios" :
        return /* BusinessMobileIOS */1;
    case "legacy" :
        return /* Legacy */2;
    case "professional_mobile_android" :
        return /* ProfessionalMobileAndroid */3;
    case "professional_mobile_ios" :
        return /* ProfessionalMobileIOS */4;
    case "qwickio" :
        return /* Qwickio */5;
    case "server" :
        return /* Server */6;
    case "unspecified" :
        return /* Unspecified */7;
    case "web" :
        return /* Web */8;
    default:
      return /* FutureAddedValue */{
              _0: x
            };
  }
}

function parseApiResponse(param) {
  if (typeof param === "string") {
    if (param === "UNSPECIFIED") {
      return /* Unspecified */7;
    } else if (param === "PROFESSIONAL_MOBILE_ANDROID") {
      return /* ProfessionalMobileAndroid */3;
    } else if (param === "BUSINESS_MOBILE_ANDROID") {
      return /* BusinessMobileAndroid */0;
    } else if (param === "WEB") {
      return /* Web */8;
    } else if (param === "PROFESSIONAL_MOBILE_IOS") {
      return /* ProfessionalMobileIOS */4;
    } else if (param === "SERVER") {
      return /* Server */6;
    } else if (param === "QWICKIO") {
      return /* Qwickio */5;
    } else if (param === "BUSINESS_MOBILE_IOS") {
      return /* BusinessMobileIOS */1;
    } else {
      return /* Legacy */2;
    }
  } else {
    return /* FutureAddedValue */{
            _0: param.VAL
          };
  }
}

function decode$1(param) {
  return Relude_Globals.$great$great(Json.Decode.string, (function (param) {
                return Relude_Result.map(fromString$1, param);
              }), param);
}

function encode$1(param) {
  return Relude_Globals.$great$great(toString$1, (function (prim) {
                return prim;
              }), param);
}

var QwickClientType = {
  toString: toString$1,
  fromString: fromString$1,
  parseApiResponse: parseApiResponse,
  decode: decode$1,
  encode: encode$1,
  header: "X-qwick-client-type"
};

function make$1(param) {
  return Relude_Globals.$great$great((function (prim) {
                return Semver.valid(prim);
              }), (function (prim) {
                if (prim == null) {
                  return ;
                } else {
                  return Caml_option.some(prim);
                }
              }), param);
}

function compare(a, b) {
  return Relude_Ordering.fromInt(Semver.compare(a, b));
}

function encode$2(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim;
              }), (function (prim) {
                return prim;
              }), param);
}

var decode$2 = Curry._1(Json.Decode.variantFromString, make$1);

var SemVer = {
  make: make$1,
  compare: compare,
  fromString: make$1,
  encode: encode$2,
  decode: decode$2
};

function version(param_0) {
  return {
          TAG: /* Version */0,
          _0: param_0
        };
}

function futureAddedValue(param_0) {
  return {
          TAG: /* FutureAddedValue */1,
          _0: param_0
        };
}

function compare$1(param) {
  var a = param[0];
  if (typeof a === "number") {
    switch (a) {
      case /* Local */0 :
          var match = param[1];
          if (typeof match === "number") {
            if (match !== 0) {
              return "less_than";
            } else {
              return "equal_to";
            }
          } else {
            return "greater_than";
          }
      case /* Legacy */1 :
          var match$1 = param[1];
          if (typeof match$1 !== "number") {
            return "greater_than";
          }
          switch (match$1) {
            case /* Local */0 :
                return "greater_than";
            case /* Legacy */1 :
                return "equal_to";
            case /* Unspecified */2 :
                return "less_than";
            
          }
      case /* Unspecified */2 :
          var match$2 = param[1];
          if (typeof match$2 === "number" && match$2 >= 2) {
            return "equal_to";
          } else {
            return "greater_than";
          }
      
    }
  } else {
    if (a.TAG === /* Version */0) {
      var b = param[1];
      if (typeof b === "number") {
        return "less_than";
      } else if (b.TAG === /* Version */0) {
        return Relude_Ordering.fromInt(Semver.compare(a._0, b._0));
      } else {
        return "greater_than";
      }
    }
    var b$1 = param[1];
    if (typeof b$1 === "number" || b$1.TAG !== /* FutureAddedValue */1) {
      return "less_than";
    } else {
      return Curry._2(Relude_String.compare, a._0, b$1._0);
    }
  }
}

function compare$2(a, b) {
  return compare$1([
              a,
              b
            ]);
}

function eq(a, b) {
  return compare$1([
              a,
              b
            ]) === "equal_to";
}

var Ord = {
  compare: compare$2,
  eq: eq
};

function fromString$2(maybeSemVer) {
  switch (maybeSemVer) {
    case "legacy" :
        return /* Legacy */1;
    case "local" :
        return /* Local */0;
    case "unspecified" :
        return /* Unspecified */2;
    default:
      return Relude_Option.fold({
                  TAG: /* FutureAddedValue */1,
                  _0: maybeSemVer
                }, version, make$1(maybeSemVer));
  }
}

function toString$2(v) {
  if (typeof v !== "number") {
    return v._0;
  }
  switch (v) {
    case /* Local */0 :
        return "local";
    case /* Legacy */1 :
        return "legacy";
    case /* Unspecified */2 :
        return "unspecified";
    
  }
}

function encode$3(param) {
  return Relude_Globals.$great$great(toString$2, (function (prim) {
                return prim;
              }), param);
}

var decode$3 = Curry._1(Json.Decode.variantFromString, (function (param) {
        return Relude_Globals.$great$great(fromString$2, Relude_Option.pure, param);
      }));

var $$Map = Relude_Map.WithOrd({
      eq: eq,
      compare: compare$2
    });

var $$Set = Relude_Set.WithOrd({
      eq: eq,
      compare: compare$2
    });

var GraphQL_API = {
  parse: fromString$2,
  serialize: toString$2
};

var QwickClientVersion = {
  local: /* Local */0,
  legacy: /* Legacy */1,
  unspecified: /* Unspecified */2,
  version: version,
  futureAddedValue: futureAddedValue,
  compare: compare$2,
  eq: eq,
  Ord: Ord,
  fromString: fromString$2,
  toString: toString$2,
  encode: encode$3,
  decode: decode$3,
  $$Map: $$Map,
  $$Set: $$Set,
  header: "X-qwick-client-version",
  GraphQL_API: GraphQL_API
};

function eq$1(param) {
  var a = param[0];
  if (typeof a === "number") {
    switch (a) {
      case /* Legacy */0 :
          var match = param[1];
          if (typeof match === "number") {
            return match === 0;
          } else {
            return false;
          }
      case /* Server */1 :
          var match$1 = param[1];
          if (typeof match$1 === "number") {
            return match$1 === 1;
          } else {
            return false;
          }
      case /* Unspecified */2 :
          var match$2 = param[1];
          if (typeof match$2 === "number") {
            return match$2 >= 2;
          } else {
            return false;
          }
      
    }
  } else {
    switch (a.TAG | 0) {
      case /* BusinessMobileAndroid */0 :
          var b = param[1];
          if (typeof b === "number" || b.TAG !== /* BusinessMobileAndroid */0) {
            return false;
          } else {
            return eq(a._0, b._0);
          }
      case /* BusinessMobileIOS */1 :
          var b$1 = param[1];
          if (typeof b$1 === "number" || b$1.TAG !== /* BusinessMobileIOS */1) {
            return false;
          } else {
            return eq(a._0, b$1._0);
          }
      case /* ProfessionalMobileAndroid */2 :
          var b$2 = param[1];
          if (typeof b$2 === "number" || b$2.TAG !== /* ProfessionalMobileAndroid */2) {
            return false;
          } else {
            return eq(a._0, b$2._0);
          }
      case /* ProfessionalMobileIOS */3 :
          var b$3 = param[1];
          if (typeof b$3 === "number" || b$3.TAG !== /* ProfessionalMobileIOS */3) {
            return false;
          } else {
            return eq(a._0, b$3._0);
          }
      case /* Qwickio */4 :
          var b$4 = param[1];
          if (typeof b$4 === "number" || b$4.TAG !== /* Qwickio */4) {
            return false;
          } else {
            return eq(a._0, b$4._0);
          }
      case /* Web */5 :
          var b$5 = param[1];
          if (typeof b$5 === "number" || b$5.TAG !== /* Web */5) {
            return false;
          } else {
            return eq(a._0, b$5._0);
          }
      case /* FutureAddedClientValue */6 :
          var match$3 = param[1];
          if (typeof match$3 === "number" || !(match$3.TAG === /* FutureAddedClientValue */6 && Relude_String.eq(a._0, match$3._0))) {
            return false;
          } else {
            return eq(a._1, match$3._1);
          }
      
    }
  }
}

function eq$2(param, param$1) {
  return Relude_Function.curry2(eq$1, param, param$1);
}

function toString$3(str) {
  if (typeof str === "number") {
    switch (str) {
      case /* Legacy */0 :
          return "Legacy";
      case /* Server */1 :
          return "Server";
      case /* Unspecified */2 :
          return "Unspecified";
      
    }
  } else {
    switch (str.TAG | 0) {
      case /* BusinessMobileAndroid */0 :
      case /* ProfessionalMobileAndroid */2 :
          return "Android " + toString$2(str._0);
      case /* BusinessMobileIOS */1 :
      case /* ProfessionalMobileIOS */3 :
          return "IOS " + toString$2(str._0);
      case /* Qwickio */4 :
          return "Qwickio " + toString$2(str._0);
      case /* Web */5 :
          return "Web " + toString$2(str._0);
      case /* FutureAddedClientValue */6 :
          return "Unknown Client value: " + (str._0 + (" with version: " + toString$2(str._1)));
      
    }
  }
}

function fromString$3(str, version) {
  var client = fromString$1(str);
  if (typeof client !== "number") {
    return {
            TAG: /* FutureAddedClientValue */6,
            _0: client._0,
            _1: version
          };
  }
  switch (client) {
    case /* BusinessMobileAndroid */0 :
        return {
                TAG: /* BusinessMobileAndroid */0,
                _0: version
              };
    case /* BusinessMobileIOS */1 :
        return {
                TAG: /* BusinessMobileIOS */1,
                _0: version
              };
    case /* Legacy */2 :
        return /* Legacy */0;
    case /* ProfessionalMobileAndroid */3 :
        return {
                TAG: /* ProfessionalMobileAndroid */2,
                _0: version
              };
    case /* ProfessionalMobileIOS */4 :
        return {
                TAG: /* ProfessionalMobileIOS */3,
                _0: version
              };
    case /* Qwickio */5 :
        return {
                TAG: /* Qwickio */4,
                _0: version
              };
    case /* Server */6 :
    case /* Unspecified */7 :
    case /* Web */8 :
        return {
                TAG: /* Web */5,
                _0: version
              };
    
  }
}

function getTypeAndVersion(client, version) {
  var match = Relude_Option.map(parseApiResponse, client);
  if (match === undefined) {
    return /* Unspecified */2;
  }
  if (typeof match !== "number") {
    return {
            TAG: /* FutureAddedClientValue */6,
            _0: match._0,
            _1: version
          };
  }
  switch (match) {
    case /* BusinessMobileAndroid */0 :
        return {
                TAG: /* BusinessMobileAndroid */0,
                _0: version
              };
    case /* BusinessMobileIOS */1 :
        return {
                TAG: /* BusinessMobileIOS */1,
                _0: version
              };
    case /* Legacy */2 :
        return /* Legacy */0;
    case /* ProfessionalMobileAndroid */3 :
        return {
                TAG: /* ProfessionalMobileAndroid */2,
                _0: version
              };
    case /* ProfessionalMobileIOS */4 :
        return {
                TAG: /* ProfessionalMobileIOS */3,
                _0: version
              };
    case /* Qwickio */5 :
        return {
                TAG: /* Qwickio */4,
                _0: version
              };
    case /* Server */6 :
    case /* Unspecified */7 :
    case /* Web */8 :
        return {
                TAG: /* Web */5,
                _0: version
              };
    
  }
}

var QwickClientTypeAndVersion = {
  eq: eq$2,
  toString: toString$3,
  fromString: fromString$3,
  getTypeAndVersion: getTypeAndVersion
};

function make$2(ios, android) {
  return {
          ios: ios,
          android: android
        };
}

var CurrentAppVersions = {
  make: make$2
};

function toString$4(param) {
  if (param) {
    return "android";
  } else {
    return "apple";
  }
}

function fromString$4(param) {
  switch (param) {
    case "android" :
        return /* Android */1;
    case "apple" :
        return /* Apple */0;
    default:
      return ;
  }
}

function decode$4(json) {
  return Curry._2(Json.Decode.$great$great$eq, Curry._2(Json.Decode.$less$hash$great, Curry._1(Json.Decode.string, json), fromString$4), Curry._1(Json.Decode.ResultUtil.note, {
                  TAG: /* Val */0,
                  _0: "ExpectedValidOption",
                  _1: json
                }));
}

function encode$4(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(toString$4, StringUtils.toUpperCase, param);
              }), (function (prim) {
                return prim;
              }), param);
}

var MobilePlatform = {
  toString: toString$4,
  fromString: fromString$4,
  decode: decode$4,
  encode: encode$4
};

function encode$5(param) {
  return Relude_Globals.$great$great((function (param) {
                if (param) {
                  return "CLOCK_OUT";
                } else {
                  return "CLOCK_IN";
                }
              }), (function (prim) {
                return prim;
              }), param);
}

var WorkerShiftVerificationType = {
  encode: encode$5
};

function fromEnum$1(param) {
  if (typeof param === "number") {
    return param;
  } else {
    return 13;
  }
}

function toEnum$1(param) {
  switch (param) {
    case 0 :
        return /* BohVip */0;
    case 1 :
        return /* FohVip */1;
    case 2 :
        return /* SpanishSpeaking */2;
    case 3 :
        return /* Waitron */3;
    case 4 :
        return /* MomaCertifiedManager */4;
    case 5 :
        return /* MomaTrainingCompleted */5;
    case 6 :
        return /* ChexologyTrainingCompleted */6;
    case 7 :
        return /* COVIDCertified */7;
    case 8 :
        return /* HiredByBusiness */8;
    case 9 :
        return /* VirtuallyOriented */9;
    case 10 :
        return /* ShiftInvitesOnHold */10;
    case 11 :
        return /* DeactivatedChurned */11;
    case 12 :
        return /* VaccineCardUploaded */12;
    default:
      return ;
  }
}

var include$1 = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum$1,
      toEnum: toEnum$1
    });

function toString$5(str) {
  if (typeof str !== "number") {
    return str._0;
  }
  switch (str) {
    case /* BohVip */0 :
        return "boh vip";
    case /* FohVip */1 :
        return "foh vip";
    case /* SpanishSpeaking */2 :
        return "spanish speaking";
    case /* Waitron */3 :
        return "waitron";
    case /* MomaCertifiedManager */4 :
        return "moma certified manager";
    case /* MomaTrainingCompleted */5 :
        return "moma training completed";
    case /* ChexologyTrainingCompleted */6 :
        return "chexology training completed";
    case /* COVIDCertified */7 :
        return "covid certified";
    case /* HiredByBusiness */8 :
        return "hired by business";
    case /* VirtuallyOriented */9 :
        return "virtually oriented";
    case /* ShiftInvitesOnHold */10 :
        return "shift invites on hold";
    case /* DeactivatedChurned */11 :
        return "deactivated churned";
    case /* VaccineCardUploaded */12 :
        return "vaccine card uploaded";
    
  }
}

function toApiString(str) {
  if (typeof str !== "number") {
    return str._0;
  }
  switch (str) {
    case /* BohVip */0 :
        return "BOH_VIP";
    case /* FohVip */1 :
        return "FOH_VIP";
    case /* SpanishSpeaking */2 :
        return "SPANISH_SPEAKING";
    case /* Waitron */3 :
        return "WAITRON";
    case /* MomaCertifiedManager */4 :
        return "MOMA_CERTIFIED_MANAGER";
    case /* MomaTrainingCompleted */5 :
        return "MOMA_TRAINING_COMPLETED";
    case /* ChexologyTrainingCompleted */6 :
        return "CHEXOLOGY_TRAINING_COMPLETED";
    case /* COVIDCertified */7 :
        return "COVID_CERTIFIED";
    case /* HiredByBusiness */8 :
        return "HIRED_BY_BUSINESS";
    case /* VirtuallyOriented */9 :
        return "VIRTUALLY_ORIENTED";
    case /* ShiftInvitesOnHold */10 :
        return "SHIFT_INVITES_ON_HOLD";
    case /* DeactivatedChurned */11 :
        return "DEACTIVATED_CHURNED";
    case /* VaccineCardUploaded */12 :
        return "VACCINE_CARD_UPLOADED";
    
  }
}

function parseApiResponse$1(param) {
  if (typeof param === "string") {
    if (param === "WAITRON") {
      return /* Waitron */3;
    } else if (param === "SHIFT_INVITES_ON_HOLD") {
      return /* ShiftInvitesOnHold */10;
    } else if (param === "DEACTIVATED_CHURNED") {
      return /* DeactivatedChurned */11;
    } else if (param === "SPANISH_SPEAKING") {
      return /* SpanishSpeaking */2;
    } else if (param === "BOH_VIP") {
      return /* BohVip */0;
    } else if (param === "VIRTUALLY_ORIENTED") {
      return /* VirtuallyOriented */9;
    } else if (param === "HIRED_BY_BUSINESS") {
      return /* HiredByBusiness */8;
    } else if (param === "COVID_CERTIFIED") {
      return /* COVIDCertified */7;
    } else if (param === "MOMA_CERTIFIED_MANAGER") {
      return /* MomaCertifiedManager */4;
    } else if (param === "MOMA_TRAINING_COMPLETED") {
      return /* MomaTrainingCompleted */5;
    } else if (param === "FOH_VIP") {
      return /* FohVip */1;
    } else if (param === "CHEXOLOGY_TRAINING_COMPLETED") {
      return /* ChexologyTrainingCompleted */6;
    } else {
      return /* VaccineCardUploaded */12;
    }
  } else {
    return /* FutureAddedValue */{
            _0: param.VAL
          };
  }
}

function encode$6(param) {
  return Relude_Globals.$great$great(toApiString, (function (prim) {
                return prim;
              }), param);
}

var WorkerTag_fromEnum = include$1.fromEnum;

var WorkerTag_toEnum = include$1.toEnum;

var WorkerTag_eq = include$1.eq;

var WorkerTag_compare = include$1.compare;

var WorkerTag_Ord = include$1.Ord;

var WorkerTag_compareWithConversion = include$1.compareWithConversion;

var WorkerTag_compareReversed = include$1.compareReversed;

var WorkerTag_OrdReversed = include$1.OrdReversed;

var WorkerTag_compareAsInt = include$1.compareAsInt;

var WorkerTag_min = include$1.min;

var WorkerTag_max = include$1.max;

var WorkerTag_lessThan = include$1.lessThan;

var WorkerTag_lt = include$1.lt;

var WorkerTag_lessThanOrEq = include$1.lessThanOrEq;

var WorkerTag_lte = include$1.lte;

var WorkerTag_greaterThan = include$1.greaterThan;

var WorkerTag_gt = include$1.gt;

var WorkerTag_greaterThanOrEq = include$1.greaterThanOrEq;

var WorkerTag_gte = include$1.gte;

var WorkerTag_clamp = include$1.clamp;

var WorkerTag_between = include$1.between;

var WorkerTag_OrdRingExtensions = include$1.OrdRingExtensions;

var WorkerTag_OrdNamed = include$1.OrdNamed;

var WorkerTag_OrdBy = include$1.OrdBy;

var WorkerTag_Set = include$1.$$Set;

var WorkerTag_SetWithNone = include$1.SetWithNone;

var WorkerTag_Map = include$1.$$Map;

var WorkerTag_list = include$1.list;

var WorkerTag_array = include$1.array;

var WorkerTag_set = include$1.set;

var WorkerTag_setWithNone = include$1.setWithNone;

var WorkerTag_cardinality = include$1.cardinality;

var WorkerTag_top = include$1.top;

var WorkerTag_bottom = include$1.bottom;

var WorkerTag_succ = include$1.succ;

var WorkerTag_pred = include$1.pred;

var WorkerTag = {
  fromEnum: WorkerTag_fromEnum,
  toEnum: WorkerTag_toEnum,
  eq: WorkerTag_eq,
  compare: WorkerTag_compare,
  Ord: WorkerTag_Ord,
  compareWithConversion: WorkerTag_compareWithConversion,
  compareReversed: WorkerTag_compareReversed,
  OrdReversed: WorkerTag_OrdReversed,
  compareAsInt: WorkerTag_compareAsInt,
  min: WorkerTag_min,
  max: WorkerTag_max,
  lessThan: WorkerTag_lessThan,
  lt: WorkerTag_lt,
  lessThanOrEq: WorkerTag_lessThanOrEq,
  lte: WorkerTag_lte,
  greaterThan: WorkerTag_greaterThan,
  gt: WorkerTag_gt,
  greaterThanOrEq: WorkerTag_greaterThanOrEq,
  gte: WorkerTag_gte,
  clamp: WorkerTag_clamp,
  between: WorkerTag_between,
  OrdRingExtensions: WorkerTag_OrdRingExtensions,
  OrdNamed: WorkerTag_OrdNamed,
  OrdBy: WorkerTag_OrdBy,
  $$Set: WorkerTag_Set,
  SetWithNone: WorkerTag_SetWithNone,
  $$Map: WorkerTag_Map,
  list: WorkerTag_list,
  array: WorkerTag_array,
  set: WorkerTag_set,
  setWithNone: WorkerTag_setWithNone,
  cardinality: WorkerTag_cardinality,
  top: WorkerTag_top,
  bottom: WorkerTag_bottom,
  succ: WorkerTag_succ,
  pred: WorkerTag_pred,
  toString: toString$5,
  toApiString: toApiString,
  parseApiResponse: parseApiResponse$1,
  encode: encode$6
};

function toEnum$2(param) {
  switch (param) {
    case 0 :
        return /* NotCompleted */0;
    case 1 :
        return /* Pending */1;
    case 2 :
        return /* Consider */2;
    case 3 :
        return /* Clear */3;
    case 4 :
        return /* Suspended */4;
    default:
      return ;
  }
}

function fromEnum$2(param) {
  if (typeof param === "number") {
    return param;
  } else {
    return 5;
  }
}

var include$2 = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum$2,
      toEnum: toEnum$2
    });

function fromString$5(param) {
  switch (param) {
    case "clear" :
        return /* Clear */3;
    case "consider" :
        return /* Consider */2;
    case "not completed" :
        return /* NotCompleted */0;
    case "pending" :
        return /* Pending */1;
    case "suspended" :
        return /* Suspended */4;
    default:
      return ;
  }
}

function fromString$6(str) {
  return Relude_Option.getOrElse(/* FutureAddedValue */{
              _0: str
            }, fromString$5(Relude_String.toLowerCase(str)));
}

function toString$6(str) {
  if (typeof str !== "number") {
    return str._0;
  }
  switch (str) {
    case /* NotCompleted */0 :
        return "not completed";
    case /* Pending */1 :
        return "pending";
    case /* Consider */2 :
        return "consider";
    case /* Clear */3 :
        return "clear";
    case /* Suspended */4 :
        return "suspended";
    
  }
}

function toApiString$1(str) {
  if (typeof str !== "number") {
    return str._0;
  }
  switch (str) {
    case /* NotCompleted */0 :
        return "NOT_COMPLETED";
    case /* Pending */1 :
        return "PENDING";
    case /* Consider */2 :
        return "CONSIDER";
    case /* Clear */3 :
        return "CLEAR";
    case /* Suspended */4 :
        return "SUSPENDED";
    
  }
}

function parseApiResponse$2(param) {
  if (typeof param === "string") {
    if (param === "SUSPENDED") {
      return /* Suspended */4;
    } else if (param === "CONSIDER") {
      return /* Consider */2;
    } else if (param === "NOT_COMPLETED") {
      return /* NotCompleted */0;
    } else if (param === "PENDING") {
      return /* Pending */1;
    } else {
      return /* Clear */3;
    }
  } else {
    return /* FutureAddedValue */{
            _0: param.VAL
          };
  }
}

function encode$7(param) {
  return Relude_Globals.$great$great(toApiString$1, (function (prim) {
                return prim;
              }), param);
}

var BackgroundCheckStatus_fromEnum = include$2.fromEnum;

var BackgroundCheckStatus_toEnum = include$2.toEnum;

var BackgroundCheckStatus_eq = include$2.eq;

var BackgroundCheckStatus_compare = include$2.compare;

var BackgroundCheckStatus_Ord = include$2.Ord;

var BackgroundCheckStatus_compareWithConversion = include$2.compareWithConversion;

var BackgroundCheckStatus_compareReversed = include$2.compareReversed;

var BackgroundCheckStatus_OrdReversed = include$2.OrdReversed;

var BackgroundCheckStatus_compareAsInt = include$2.compareAsInt;

var BackgroundCheckStatus_min = include$2.min;

var BackgroundCheckStatus_max = include$2.max;

var BackgroundCheckStatus_lessThan = include$2.lessThan;

var BackgroundCheckStatus_lt = include$2.lt;

var BackgroundCheckStatus_lessThanOrEq = include$2.lessThanOrEq;

var BackgroundCheckStatus_lte = include$2.lte;

var BackgroundCheckStatus_greaterThan = include$2.greaterThan;

var BackgroundCheckStatus_gt = include$2.gt;

var BackgroundCheckStatus_greaterThanOrEq = include$2.greaterThanOrEq;

var BackgroundCheckStatus_gte = include$2.gte;

var BackgroundCheckStatus_clamp = include$2.clamp;

var BackgroundCheckStatus_between = include$2.between;

var BackgroundCheckStatus_OrdRingExtensions = include$2.OrdRingExtensions;

var BackgroundCheckStatus_OrdNamed = include$2.OrdNamed;

var BackgroundCheckStatus_OrdBy = include$2.OrdBy;

var BackgroundCheckStatus_Set = include$2.$$Set;

var BackgroundCheckStatus_SetWithNone = include$2.SetWithNone;

var BackgroundCheckStatus_Map = include$2.$$Map;

var BackgroundCheckStatus_list = include$2.list;

var BackgroundCheckStatus_array = include$2.array;

var BackgroundCheckStatus_set = include$2.set;

var BackgroundCheckStatus_setWithNone = include$2.setWithNone;

var BackgroundCheckStatus_cardinality = include$2.cardinality;

var BackgroundCheckStatus_top = include$2.top;

var BackgroundCheckStatus_bottom = include$2.bottom;

var BackgroundCheckStatus_succ = include$2.succ;

var BackgroundCheckStatus_pred = include$2.pred;

var BackgroundCheckStatus = {
  fromEnum: BackgroundCheckStatus_fromEnum,
  toEnum: BackgroundCheckStatus_toEnum,
  eq: BackgroundCheckStatus_eq,
  compare: BackgroundCheckStatus_compare,
  Ord: BackgroundCheckStatus_Ord,
  compareWithConversion: BackgroundCheckStatus_compareWithConversion,
  compareReversed: BackgroundCheckStatus_compareReversed,
  OrdReversed: BackgroundCheckStatus_OrdReversed,
  compareAsInt: BackgroundCheckStatus_compareAsInt,
  min: BackgroundCheckStatus_min,
  max: BackgroundCheckStatus_max,
  lessThan: BackgroundCheckStatus_lessThan,
  lt: BackgroundCheckStatus_lt,
  lessThanOrEq: BackgroundCheckStatus_lessThanOrEq,
  lte: BackgroundCheckStatus_lte,
  greaterThan: BackgroundCheckStatus_greaterThan,
  gt: BackgroundCheckStatus_gt,
  greaterThanOrEq: BackgroundCheckStatus_greaterThanOrEq,
  gte: BackgroundCheckStatus_gte,
  clamp: BackgroundCheckStatus_clamp,
  between: BackgroundCheckStatus_between,
  OrdRingExtensions: BackgroundCheckStatus_OrdRingExtensions,
  OrdNamed: BackgroundCheckStatus_OrdNamed,
  OrdBy: BackgroundCheckStatus_OrdBy,
  $$Set: BackgroundCheckStatus_Set,
  SetWithNone: BackgroundCheckStatus_SetWithNone,
  $$Map: BackgroundCheckStatus_Map,
  list: BackgroundCheckStatus_list,
  array: BackgroundCheckStatus_array,
  set: BackgroundCheckStatus_set,
  setWithNone: BackgroundCheckStatus_setWithNone,
  cardinality: BackgroundCheckStatus_cardinality,
  top: BackgroundCheckStatus_top,
  bottom: BackgroundCheckStatus_bottom,
  succ: BackgroundCheckStatus_succ,
  pred: BackgroundCheckStatus_pred,
  fromString: fromString$6,
  toString: toString$6,
  toApiString: toApiString$1,
  parseApiResponse: parseApiResponse$2,
  encode: encode$7
};

function parseApiResponse$3(response) {
  try {
    if (response === "TOO_FAR") {
      return /* TooFar */5;
    } else if (response === "ATTIRE") {
      return /* Attire */0;
    } else if (response === "SCHEDULE_CONFLICT") {
      return /* ScheduleConflict */3;
    } else if (response === "OTHER") {
      return /* Other */2;
    } else if (response === "SICK") {
      return /* Sick */4;
    } else {
      return /* LowPay */1;
    }
  }
  catch (exn){
    return ;
  }
}

function fromString$7(param) {
  return Relude_Globals.$great$great(Relude_String.toLowerCase, (function (param) {
                switch (param) {
                  case "attire" :
                      return /* Attire */0;
                  case "low pay" :
                      return /* LowPay */1;
                  case "other" :
                      return /* Other */2;
                  case "schedule conflict" :
                      return /* ScheduleConflict */3;
                  case "sick" :
                      return /* Sick */4;
                  case "too far" :
                      return /* TooFar */5;
                  default:
                    return ;
                }
              }), param);
}

function toString$7(param) {
  switch (param) {
    case /* Attire */0 :
        return "Attire";
    case /* LowPay */1 :
        return "Low Pay";
    case /* Other */2 :
        return "Other";
    case /* ScheduleConflict */3 :
        return "Schedule Conflict";
    case /* Sick */4 :
        return "Sick";
    case /* TooFar */5 :
        return "Too Far";
    
  }
}

function toApiString$2(param) {
  switch (param) {
    case /* Attire */0 :
        return "ATTIRE";
    case /* LowPay */1 :
        return "LOW_PAY";
    case /* Other */2 :
        return "OTHER";
    case /* ScheduleConflict */3 :
        return "SCHEDULE_CONFLICT";
    case /* Sick */4 :
        return "SICK";
    case /* TooFar */5 :
        return "TOO_FAR";
    
  }
}

function fromEnum$3(param) {
  switch (param) {
    case /* Attire */0 :
        return 4;
    case /* LowPay */1 :
        return 0;
    case /* Other */2 :
        return 5;
    case /* ScheduleConflict */3 :
        return 1;
    case /* Sick */4 :
        return 3;
    case /* TooFar */5 :
        return 2;
    
  }
}

function toEnum$3(param) {
  switch (param) {
    case 0 :
        return /* LowPay */1;
    case 1 :
        return /* ScheduleConflict */3;
    case 2 :
        return /* TooFar */5;
    case 3 :
        return /* Sick */4;
    case 4 :
        return /* Attire */0;
    case 5 :
        return /* Other */2;
    default:
      return ;
  }
}

var include$3 = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum$3,
      toEnum: toEnum$3
    });

var decode$5 = Curry._1(Json.Decode.variantFromString, fromString$7);

var ShiftDeclineReason_fromEnum = include$3.fromEnum;

var ShiftDeclineReason_toEnum = include$3.toEnum;

var ShiftDeclineReason_eq = include$3.eq;

var ShiftDeclineReason_compare = include$3.compare;

var ShiftDeclineReason_Ord = include$3.Ord;

var ShiftDeclineReason_compareWithConversion = include$3.compareWithConversion;

var ShiftDeclineReason_compareReversed = include$3.compareReversed;

var ShiftDeclineReason_OrdReversed = include$3.OrdReversed;

var ShiftDeclineReason_compareAsInt = include$3.compareAsInt;

var ShiftDeclineReason_min = include$3.min;

var ShiftDeclineReason_max = include$3.max;

var ShiftDeclineReason_lessThan = include$3.lessThan;

var ShiftDeclineReason_lt = include$3.lt;

var ShiftDeclineReason_lessThanOrEq = include$3.lessThanOrEq;

var ShiftDeclineReason_lte = include$3.lte;

var ShiftDeclineReason_greaterThan = include$3.greaterThan;

var ShiftDeclineReason_gt = include$3.gt;

var ShiftDeclineReason_greaterThanOrEq = include$3.greaterThanOrEq;

var ShiftDeclineReason_gte = include$3.gte;

var ShiftDeclineReason_clamp = include$3.clamp;

var ShiftDeclineReason_between = include$3.between;

var ShiftDeclineReason_OrdRingExtensions = include$3.OrdRingExtensions;

var ShiftDeclineReason_OrdNamed = include$3.OrdNamed;

var ShiftDeclineReason_OrdBy = include$3.OrdBy;

var ShiftDeclineReason_Set = include$3.$$Set;

var ShiftDeclineReason_SetWithNone = include$3.SetWithNone;

var ShiftDeclineReason_Map = include$3.$$Map;

var ShiftDeclineReason_list = include$3.list;

var ShiftDeclineReason_array = include$3.array;

var ShiftDeclineReason_set = include$3.set;

var ShiftDeclineReason_setWithNone = include$3.setWithNone;

var ShiftDeclineReason_cardinality = include$3.cardinality;

var ShiftDeclineReason_top = include$3.top;

var ShiftDeclineReason_bottom = include$3.bottom;

var ShiftDeclineReason_succ = include$3.succ;

var ShiftDeclineReason_pred = include$3.pred;

var ShiftDeclineReason = {
  parseApiResponse: parseApiResponse$3,
  fromString: fromString$7,
  toString: toString$7,
  toApiString: toApiString$2,
  fromEnum: ShiftDeclineReason_fromEnum,
  toEnum: ShiftDeclineReason_toEnum,
  eq: ShiftDeclineReason_eq,
  compare: ShiftDeclineReason_compare,
  Ord: ShiftDeclineReason_Ord,
  compareWithConversion: ShiftDeclineReason_compareWithConversion,
  compareReversed: ShiftDeclineReason_compareReversed,
  OrdReversed: ShiftDeclineReason_OrdReversed,
  compareAsInt: ShiftDeclineReason_compareAsInt,
  min: ShiftDeclineReason_min,
  max: ShiftDeclineReason_max,
  lessThan: ShiftDeclineReason_lessThan,
  lt: ShiftDeclineReason_lt,
  lessThanOrEq: ShiftDeclineReason_lessThanOrEq,
  lte: ShiftDeclineReason_lte,
  greaterThan: ShiftDeclineReason_greaterThan,
  gt: ShiftDeclineReason_gt,
  greaterThanOrEq: ShiftDeclineReason_greaterThanOrEq,
  gte: ShiftDeclineReason_gte,
  clamp: ShiftDeclineReason_clamp,
  between: ShiftDeclineReason_between,
  OrdRingExtensions: ShiftDeclineReason_OrdRingExtensions,
  OrdNamed: ShiftDeclineReason_OrdNamed,
  OrdBy: ShiftDeclineReason_OrdBy,
  $$Set: ShiftDeclineReason_Set,
  SetWithNone: ShiftDeclineReason_SetWithNone,
  $$Map: ShiftDeclineReason_Map,
  list: ShiftDeclineReason_list,
  array: ShiftDeclineReason_array,
  set: ShiftDeclineReason_set,
  setWithNone: ShiftDeclineReason_setWithNone,
  cardinality: ShiftDeclineReason_cardinality,
  top: ShiftDeclineReason_top,
  bottom: ShiftDeclineReason_bottom,
  succ: ShiftDeclineReason_succ,
  pred: ShiftDeclineReason_pred,
  decode: decode$5
};

function create(reason, comment) {
  return {
          reason: reason,
          comment: comment
        };
}

function encode$8(param) {
  return Json.Encode.object_({
              hd: [
                "reason",
                toApiString$2(param.reason)
              ],
              tl: {
                hd: [
                  "comment",
                  Json.Encode.optional((function (prim) {
                          return prim;
                        }), param.comment)
                ],
                tl: /* [] */0
              }
            });
}

var ShiftDeclineReasonAndComment = {
  create: create,
  encode: encode$8
};

function parseApiResponse$4(response) {
  try {
    if (typeof response === "string") {
      if (response === "COVID_CONCERN") {
        return /* COVIDConcern */1;
      } else if (response === "ATTIRE") {
        return /* Attire */0;
      } else if (response === "TRANSPORTATION") {
        return /* Transportation */6;
      } else if (response === "SCHEDULE_CONFLICT") {
        return /* ScheduleConflict */3;
      } else if (response === "OTHER") {
        return /* Other */2;
      } else if (response === "SICK") {
        return /* Sick */4;
      } else {
        return /* TooFar */5;
      }
    } else {
      return /* FutureAddedValue */{
              _0: response.VAL
            };
    }
  }
  catch (exn){
    return ;
  }
}

function fromString$8(param) {
  return Relude_Globals.$great$great(Relude_String.toLowerCase, (function (param) {
                switch (param) {
                  case "attire issues" :
                      return /* Attire */0;
                  case "covid concern" :
                      return /* COVIDConcern */1;
                  case "i'm feeling sick" :
                      return /* Sick */4;
                  case "other" :
                      return /* Other */2;
                  case "schedule conflict" :
                      return /* ScheduleConflict */3;
                  case "too far away" :
                      return /* TooFar */5;
                  case "transportation issues" :
                      return /* Transportation */6;
                  default:
                    return ;
                }
              }), param);
}

function toString$8(str) {
  if (typeof str !== "number") {
    return str._0;
  }
  switch (str) {
    case /* Attire */0 :
        return "Attire Issues";
    case /* COVIDConcern */1 :
        return "COVID Concern";
    case /* Other */2 :
        return "Other";
    case /* ScheduleConflict */3 :
        return "Schedule Conflict";
    case /* Sick */4 :
        return "I'm Feeling Sick";
    case /* TooFar */5 :
        return "Too Far Away";
    case /* Transportation */6 :
        return "Transportation Issues";
    
  }
}

function toApiString$3(str) {
  if (typeof str !== "number") {
    return str._0;
  }
  switch (str) {
    case /* Attire */0 :
        return "ATTIRE";
    case /* COVIDConcern */1 :
        return "COVID_CONCERN";
    case /* Other */2 :
        return "OTHER";
    case /* ScheduleConflict */3 :
        return "SCHEDULE_CONFLICT";
    case /* Sick */4 :
        return "SICK";
    case /* TooFar */5 :
        return "TOO_FAR";
    case /* Transportation */6 :
        return "TRANSPORTATION";
    
  }
}

function fromEnum$4(param) {
  if (typeof param !== "number") {
    return 7;
  }
  switch (param) {
    case /* Attire */0 :
        return 2;
    case /* COVIDConcern */1 :
        return 5;
    case /* Other */2 :
        return 6;
    case /* ScheduleConflict */3 :
        return 0;
    case /* Sick */4 :
        return 4;
    case /* TooFar */5 :
        return 1;
    case /* Transportation */6 :
        return 3;
    
  }
}

function toEnum$4(param) {
  switch (param) {
    case 0 :
        return /* ScheduleConflict */3;
    case 1 :
        return /* TooFar */5;
    case 2 :
        return /* Attire */0;
    case 3 :
        return /* Transportation */6;
    case 4 :
        return /* Sick */4;
    case 5 :
        return /* COVIDConcern */1;
    case 6 :
        return /* Other */2;
    default:
      return ;
  }
}

var include$4 = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum$4,
      toEnum: toEnum$4
    });

var decode$6 = Curry._1(Json.Decode.variantFromString, fromString$8);

var WorkerShiftCancelReason_fromEnum = include$4.fromEnum;

var WorkerShiftCancelReason_toEnum = include$4.toEnum;

var WorkerShiftCancelReason_eq = include$4.eq;

var WorkerShiftCancelReason_compare = include$4.compare;

var WorkerShiftCancelReason_Ord = include$4.Ord;

var WorkerShiftCancelReason_compareWithConversion = include$4.compareWithConversion;

var WorkerShiftCancelReason_compareReversed = include$4.compareReversed;

var WorkerShiftCancelReason_OrdReversed = include$4.OrdReversed;

var WorkerShiftCancelReason_compareAsInt = include$4.compareAsInt;

var WorkerShiftCancelReason_min = include$4.min;

var WorkerShiftCancelReason_max = include$4.max;

var WorkerShiftCancelReason_lessThan = include$4.lessThan;

var WorkerShiftCancelReason_lt = include$4.lt;

var WorkerShiftCancelReason_lessThanOrEq = include$4.lessThanOrEq;

var WorkerShiftCancelReason_lte = include$4.lte;

var WorkerShiftCancelReason_greaterThan = include$4.greaterThan;

var WorkerShiftCancelReason_gt = include$4.gt;

var WorkerShiftCancelReason_greaterThanOrEq = include$4.greaterThanOrEq;

var WorkerShiftCancelReason_gte = include$4.gte;

var WorkerShiftCancelReason_clamp = include$4.clamp;

var WorkerShiftCancelReason_between = include$4.between;

var WorkerShiftCancelReason_OrdRingExtensions = include$4.OrdRingExtensions;

var WorkerShiftCancelReason_OrdNamed = include$4.OrdNamed;

var WorkerShiftCancelReason_OrdBy = include$4.OrdBy;

var WorkerShiftCancelReason_Set = include$4.$$Set;

var WorkerShiftCancelReason_SetWithNone = include$4.SetWithNone;

var WorkerShiftCancelReason_Map = include$4.$$Map;

var WorkerShiftCancelReason_list = include$4.list;

var WorkerShiftCancelReason_array = include$4.array;

var WorkerShiftCancelReason_set = include$4.set;

var WorkerShiftCancelReason_setWithNone = include$4.setWithNone;

var WorkerShiftCancelReason_cardinality = include$4.cardinality;

var WorkerShiftCancelReason_top = include$4.top;

var WorkerShiftCancelReason_bottom = include$4.bottom;

var WorkerShiftCancelReason_succ = include$4.succ;

var WorkerShiftCancelReason_pred = include$4.pred;

var WorkerShiftCancelReason = {
  parseApiResponse: parseApiResponse$4,
  fromString: fromString$8,
  toString: toString$8,
  toApiString: toApiString$3,
  fromEnum: WorkerShiftCancelReason_fromEnum,
  toEnum: WorkerShiftCancelReason_toEnum,
  eq: WorkerShiftCancelReason_eq,
  compare: WorkerShiftCancelReason_compare,
  Ord: WorkerShiftCancelReason_Ord,
  compareWithConversion: WorkerShiftCancelReason_compareWithConversion,
  compareReversed: WorkerShiftCancelReason_compareReversed,
  OrdReversed: WorkerShiftCancelReason_OrdReversed,
  compareAsInt: WorkerShiftCancelReason_compareAsInt,
  min: WorkerShiftCancelReason_min,
  max: WorkerShiftCancelReason_max,
  lessThan: WorkerShiftCancelReason_lessThan,
  lt: WorkerShiftCancelReason_lt,
  lessThanOrEq: WorkerShiftCancelReason_lessThanOrEq,
  lte: WorkerShiftCancelReason_lte,
  greaterThan: WorkerShiftCancelReason_greaterThan,
  gt: WorkerShiftCancelReason_gt,
  greaterThanOrEq: WorkerShiftCancelReason_greaterThanOrEq,
  gte: WorkerShiftCancelReason_gte,
  clamp: WorkerShiftCancelReason_clamp,
  between: WorkerShiftCancelReason_between,
  OrdRingExtensions: WorkerShiftCancelReason_OrdRingExtensions,
  OrdNamed: WorkerShiftCancelReason_OrdNamed,
  OrdBy: WorkerShiftCancelReason_OrdBy,
  $$Set: WorkerShiftCancelReason_Set,
  SetWithNone: WorkerShiftCancelReason_SetWithNone,
  $$Map: WorkerShiftCancelReason_Map,
  list: WorkerShiftCancelReason_list,
  array: WorkerShiftCancelReason_array,
  set: WorkerShiftCancelReason_set,
  setWithNone: WorkerShiftCancelReason_setWithNone,
  cardinality: WorkerShiftCancelReason_cardinality,
  top: WorkerShiftCancelReason_top,
  bottom: WorkerShiftCancelReason_bottom,
  succ: WorkerShiftCancelReason_succ,
  pred: WorkerShiftCancelReason_pred,
  decode: decode$6
};

function create$1(reason, comment) {
  return {
          reason: reason,
          comment: comment
        };
}

function encode$9(param) {
  return Json.Encode.object_({
              hd: [
                "reason",
                toApiString$3(param.reason)
              ],
              tl: {
                hd: [
                  "comment",
                  Json.Encode.optional((function (prim) {
                          return prim;
                        }), param.comment)
                ],
                tl: /* [] */0
              }
            });
}

var WorkerShiftCancelReasonAndComment = {
  create: create$1,
  encode: encode$9
};

var include$5 = TypeUtils.MakeOpaqueStringType({});

var fromString$9 = include$5.fromString;

var codeRegex = /^[0-9]{4}$/;

function fromString$10(maybeAuthCode) {
  var param = codeRegex.test(maybeAuthCode);
  if (param) {
    return Curry._1(fromString$9, maybeAuthCode);
  }
  
}

var AuthCode_toString = include$5.toString;

var AuthCode_decode = include$5.decode;

var AuthCode_encode = include$5.encode;

var AuthCode_compare = include$5.compare;

var AuthCode_eq = include$5.eq;

var AuthCode_Ord = include$5.Ord;

var AuthCode_Set = include$5.$$Set;

var AuthCode_Map = include$5.$$Map;

var AuthCode = {
  toString: AuthCode_toString,
  decode: AuthCode_decode,
  encode: AuthCode_encode,
  compare: AuthCode_compare,
  eq: AuthCode_eq,
  Ord: AuthCode_Ord,
  $$Set: AuthCode_Set,
  $$Map: AuthCode_Map,
  codeRegex: codeRegex,
  fromString: fromString$10
};

function business(param_0) {
  return {
          TAG: /* Business */0,
          _0: param_0
        };
}

function businessAdmin(param_0) {
  return {
          TAG: /* BusinessAdmin */1,
          _0: param_0
        };
}

function manager(param_0) {
  return {
          TAG: /* Manager */2,
          _0: param_0
        };
}

function worker(param_0) {
  return {
          TAG: /* Worker */3,
          _0: param_0
        };
}

function isWorker(param) {
  if (param.TAG === /* Worker */3) {
    return true;
  } else {
    return false;
  }
}

function getUserId(param) {
  return param._0;
}

var ProfileableUser = {
  business: business,
  businessAdmin: businessAdmin,
  manager: manager,
  worker: worker,
  isWorker: isWorker,
  getUserId: getUserId
};

function associatedUserId(param_0) {
  return {
          TAG: /* AssociatedUserId */0,
          _0: param_0
        };
}

function unknown(param_0) {
  return {
          TAG: /* Unknown */1,
          _0: param_0
        };
}

function getUserId$1(userId) {
  if (userId.TAG === /* AssociatedUserId */0) {
    return Relude_Option.pure(userId._0);
  }
  
}

function parseUserId(param) {
  return Relude_Globals.$great$great((function (param) {
                return param.replace("u", "");
              }), Relude_Int.fromString, param);
}

var decode$7 = Curry._2(Json.Decode.oneOf, (function (param) {
        return Relude_Globals.$great$great(CommonTypes_PhoneNumber.decode, (function (param) {
                      return Relude_Result.map(unknown, param);
                    }), param);
      }), {
      hd: (function (param) {
          return Relude_Globals.$great$great((function (param) {
                        return Relude_Globals.$great$great((function (param) {
                                      return Relude_Globals.$great$great(Json.Decode.string, (function (param) {
                                                    return Relude_Result.map((function (param) {
                                                                  return Relude_Globals.$great$great((function (param) {
                                                                                return Relude_String.replaceFirst("u", "", param);
                                                                              }), (function (prim) {
                                                                                return prim;
                                                                              }), param);
                                                                }), param);
                                                  }), param);
                                    }), (function (param) {
                                      return Relude_Result.flatMap(CommonTypes_User_Id.decode, param);
                                    }), param);
                      }), (function (param) {
                        return Relude_Result.map(associatedUserId, param);
                      }), param);
        }),
      tl: {
        hd: (function (param) {
            return Relude_Globals.$great$great(CommonTypes_User_Id.decode, (function (param) {
                          return Relude_Result.map(associatedUserId, param);
                        }), param);
          }),
        tl: /* [] */0
      }
    });

function encode$10(id) {
  if (id.TAG === /* AssociatedUserId */0) {
    return "u" + Curry._1(CommonTypes_User_Id.toString, id._0);
  } else {
    return CommonTypes_PhoneNumber.encode(id._0);
  }
}

function toString$9(id) {
  if (id.TAG === /* AssociatedUserId */0) {
    return "u" + Curry._1(CommonTypes_User_Id.toString, id._0);
  } else {
    return CommonTypes_PhoneNumber.toString(id._0);
  }
}

function fromString$11(str) {
  var __x = Curry._2(Relude_Option.flatMap, (function (phoneNumber) {
          switch (phoneNumber.TAG | 0) {
            case /* LongNumber */0 :
                return Relude_Option.pure({
                            TAG: /* Unknown */1,
                            _0: phoneNumber
                          });
            case /* ShortCode */1 :
            case /* TwilioNumber */2 :
                return ;
            
          }
        }), CommonTypes_PhoneNumber.fromString(str));
  return Relude_Option.altLazy(__x, (function (param) {
                return Relude_Option.map(associatedUserId, Curry._1(CommonTypes_User_Id.fromString, Relude_String.replaceFirst("u", "", str)));
              }));
}

function compare$3(param) {
  var a = param[0];
  if (a.TAG === /* AssociatedUserId */0) {
    var b = param[1];
    if (b.TAG === /* AssociatedUserId */0) {
      return Curry._2(CommonTypes_User_Id.compare, a._0, b._0);
    } else {
      return "greater_than";
    }
  }
  var b$1 = param[1];
  if (b$1.TAG === /* AssociatedUserId */0) {
    return "less_than";
  } else {
    return Curry._2(CommonTypes_PhoneNumber.compare, a._0, b$1._0);
  }
}

function compare$4(param, param$1) {
  return Relude_Function.curry2(compare$3, param, param$1);
}

function eq$3(a, b) {
  return Relude_Function.curry2(compare$3, a, b) === "equal_to";
}

var Ord$1 = {
  compare: compare$4,
  eq: eq$3
};

var $$Map$1 = Relude_Map.WithOrd({
      eq: eq$3,
      compare: compare$4
    });

function parse(param) {
  return Relude_Globals.$great$great(fromString$11, Relude_Option.getOrThrow, param);
}

var GraphQL_API$1 = {
  parse: parse,
  serialize: toString$9
};

var ThreadId = {
  associatedUserId: associatedUserId,
  unknown: unknown,
  getUserId: getUserId$1,
  parseUserId: parseUserId,
  decode: decode$7,
  encode: encode$10,
  toString: toString$9,
  fromString: fromString$11,
  compare: compare$4,
  eq: eq$3,
  Ord: Ord$1,
  $$Map: $$Map$1,
  GraphQL_API: GraphQL_API$1
};

function toEnum$5(param) {
  if (param !== 0) {
    if (param !== 1) {
      return ;
    } else {
      return /* Manual */1;
    }
  } else {
    return /* Automatic */0;
  }
}

function fromEnum$5(param) {
  if (param) {
    return 1;
  } else {
    return 0;
  }
}

var include$6 = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum$5,
      toEnum: toEnum$5
    });

function fromString$12(param) {
  return Relude_Globals.$great$great(Relude_String.toLowerCase, (function (param) {
                switch (param) {
                  case "automatic" :
                      return /* Automatic */0;
                  case "manual" :
                      return /* Manual */1;
                  default:
                    return ;
                }
              }), param);
}

function toString$10(param) {
  if (param) {
    return "manual";
  } else {
    return "automatic";
  }
}

var decode$8 = Curry._1(Json.Decode.variantFromString, fromString$12);

function encode$11(param) {
  return Relude_Globals.$great$great(toString$10, (function (prim) {
                return prim;
              }), param);
}

var Catalyst_fromEnum = include$6.fromEnum;

var Catalyst_toEnum = include$6.toEnum;

var Catalyst_eq = include$6.eq;

var Catalyst_compare = include$6.compare;

var Catalyst_Ord = include$6.Ord;

var Catalyst_compareWithConversion = include$6.compareWithConversion;

var Catalyst_compareReversed = include$6.compareReversed;

var Catalyst_OrdReversed = include$6.OrdReversed;

var Catalyst_compareAsInt = include$6.compareAsInt;

var Catalyst_min = include$6.min;

var Catalyst_max = include$6.max;

var Catalyst_lessThan = include$6.lessThan;

var Catalyst_lt = include$6.lt;

var Catalyst_lessThanOrEq = include$6.lessThanOrEq;

var Catalyst_lte = include$6.lte;

var Catalyst_greaterThan = include$6.greaterThan;

var Catalyst_gt = include$6.gt;

var Catalyst_greaterThanOrEq = include$6.greaterThanOrEq;

var Catalyst_gte = include$6.gte;

var Catalyst_clamp = include$6.clamp;

var Catalyst_between = include$6.between;

var Catalyst_OrdRingExtensions = include$6.OrdRingExtensions;

var Catalyst_OrdNamed = include$6.OrdNamed;

var Catalyst_OrdBy = include$6.OrdBy;

var Catalyst_Set = include$6.$$Set;

var Catalyst_SetWithNone = include$6.SetWithNone;

var Catalyst_Map = include$6.$$Map;

var Catalyst_list = include$6.list;

var Catalyst_array = include$6.array;

var Catalyst_set = include$6.set;

var Catalyst_setWithNone = include$6.setWithNone;

var Catalyst_cardinality = include$6.cardinality;

var Catalyst_top = include$6.top;

var Catalyst_bottom = include$6.bottom;

var Catalyst_succ = include$6.succ;

var Catalyst_pred = include$6.pred;

var Catalyst = {
  fromEnum: Catalyst_fromEnum,
  toEnum: Catalyst_toEnum,
  eq: Catalyst_eq,
  compare: Catalyst_compare,
  Ord: Catalyst_Ord,
  compareWithConversion: Catalyst_compareWithConversion,
  compareReversed: Catalyst_compareReversed,
  OrdReversed: Catalyst_OrdReversed,
  compareAsInt: Catalyst_compareAsInt,
  min: Catalyst_min,
  max: Catalyst_max,
  lessThan: Catalyst_lessThan,
  lt: Catalyst_lt,
  lessThanOrEq: Catalyst_lessThanOrEq,
  lte: Catalyst_lte,
  greaterThan: Catalyst_greaterThan,
  gt: Catalyst_gt,
  greaterThanOrEq: Catalyst_greaterThanOrEq,
  gte: Catalyst_gte,
  clamp: Catalyst_clamp,
  between: Catalyst_between,
  OrdRingExtensions: Catalyst_OrdRingExtensions,
  OrdNamed: Catalyst_OrdNamed,
  OrdBy: Catalyst_OrdBy,
  $$Set: Catalyst_Set,
  SetWithNone: Catalyst_SetWithNone,
  $$Map: Catalyst_Map,
  list: Catalyst_list,
  array: Catalyst_array,
  set: Catalyst_set,
  setWithNone: Catalyst_setWithNone,
  cardinality: Catalyst_cardinality,
  top: Catalyst_top,
  bottom: Catalyst_bottom,
  succ: Catalyst_succ,
  pred: Catalyst_pred,
  fromString: fromString$12,
  toString: toString$10,
  decode: decode$8,
  encode: encode$11
};

var JwtSecret = TypeUtils.MakeOpaqueStringType({});

function toString$11(param) {
  switch (param) {
    case /* ShiftAttachments */0 :
        return "shift_attachments";
    case /* Certifications */1 :
        return "certifications";
    case /* ProfilePictures */2 :
        return "profile_pictures";
    
  }
}

var S3KeyPrefixes = {
  toString: toString$11
};

var S3Filename = TypeUtils.MakeOpaqueStringType({});

var Cents;

var CommunicationId;

var Email;

var Guid;

var Interval;

var Invoice;

var Jwt;

var MessageCategory;

var PhoneNumber;

var Shift;

var TextMessage;

var TwilioVideo;

var WorkerShift;

var ZipCode;

var Timezone;

var ShiftTypeQuestion;

var StatusCode;

var Header;

var Status;

var GeoState;

var ProfilePicture;

var City;

var User;

var QwickBlog;

var QwickScoreType;

var Survey;

var ProfileableType;

exports.Cents = Cents;
exports.CommunicationId = CommunicationId;
exports.Email = Email;
exports.Guid = Guid;
exports.Interval = Interval;
exports.Invoice = Invoice;
exports.Jwt = Jwt;
exports.MessageCategory = MessageCategory;
exports.PhoneNumber = PhoneNumber;
exports.Shift = Shift;
exports.TextMessage = TextMessage;
exports.TwilioVideo = TwilioVideo;
exports.WorkerShift = WorkerShift;
exports.SortOrder = SortOrder;
exports.Url = Url;
exports.ZipCode = ZipCode;
exports.Timezone = Timezone;
exports.QueryStringParameters = QueryStringParameters;
exports.ShiftTypeQuestion = ShiftTypeQuestion;
exports.DeployEnv = DeployEnv;
exports.StatusCode = StatusCode;
exports.Header = Header;
exports.Status = Status;
exports.QwickClientType = QwickClientType;
exports.SemVer = SemVer;
exports.QwickClientVersion = QwickClientVersion;
exports.QwickClientTypeAndVersion = QwickClientTypeAndVersion;
exports.CurrentAppVersions = CurrentAppVersions;
exports.MobilePlatform = MobilePlatform;
exports.GeoState = GeoState;
exports.ProfilePicture = ProfilePicture;
exports.City = City;
exports.User = User;
exports.WorkerShiftVerificationType = WorkerShiftVerificationType;
exports.WorkerTag = WorkerTag;
exports.BackgroundCheckStatus = BackgroundCheckStatus;
exports.ShiftDeclineReason = ShiftDeclineReason;
exports.ShiftDeclineReasonAndComment = ShiftDeclineReasonAndComment;
exports.WorkerShiftCancelReason = WorkerShiftCancelReason;
exports.WorkerShiftCancelReasonAndComment = WorkerShiftCancelReasonAndComment;
exports.AuthCode = AuthCode;
exports.QwickBlog = QwickBlog;
exports.QwickScoreType = QwickScoreType;
exports.Survey = Survey;
exports.ProfileableType = ProfileableType;
exports.ProfileableUser = ProfileableUser;
exports.ThreadId = ThreadId;
exports.Catalyst = Catalyst;
exports.JwtSecret = JwtSecret;
exports.S3KeyPrefixes = S3KeyPrefixes;
exports.S3Filename = S3Filename;
/* Url Not a pure module */
